// extracted by mini-css-extract-plugin
export default {"icons":"ConditionsCard_icons__Px+22","greyText":"ConditionsCard_greyText__nRsNM"};